import { View } from 'es6/components/view'
import dataLayer from 'init/data-layer'
import { Defaults } from 'es-decorators'

/**
 * События на которые должны реагировать Рекомендации
 */
@Defaults({
  dataLayer,
})
export class RecommendationsEvents extends View {
  /**
   * @inheritDoc
   */
  run () {
    // подписываемся на свои же события которые будут вызываться в других объектах
    this.listenTo(this, 'errorLogin', this.eventErrorLogin)
    this.listenTo(this, 'passwordRestoreByEmail', this.eventPasswordRestoreByEmail)
    this.listenTo(this, 'passwordRestoreByPhone', this.eventPasswordRestoreByPhone)
    this.listenTo(this, 'passwordRestoreErrorByEmail', this.eventPasswordRestoreErrorByEmail)
    this.listenTo(this, 'passwordRestoreErrorByPhone', this.eventPasswordRestoreErrorByPhone)
    this.listenTo(this, 'deleteItemFromCart', this.eventDeleteItemFromCart)
    this.listenTo(this, 'deleteItemsListFromCart', this.eventDeleteItemsListFromCart)
    this.listenTo(this, 'itemInFavorite', this.eventItemInFavorite)
    this.listenTo(this, 'itemOutFavorite', this.eventItemOutFavorite)
    this.listenTo(this, 'itemInCart', this.eventItemInCart)
    this.listenTo(this, 'addInCartByArticul', this.eventAddInCartByArticul)
    this.listenTo(this, 'openAddByArticulForm', this.eventOpenAddByArticulForm)
    this.listenTo(this, 'clickItemButtonRecommendation', this.eventClickItemButtonRecommendation)
    this.listenTo(this, 'clickItemImgRecommendation', this.eventClickItemImgRecommendation)
    this.listenTo(this, 'clickItemNameRecommendation', this.eventClickItemNameRecommendation)
    this.listenTo(this, 'switchProductTab', this.eventSwitchProductTab)
  }

  /**
   * Ошибка авторизации
   */
  eventErrorLogin () {
    this.pushDataToDataLayer({ 'event': 'Password_error' })
  }

  /**
   * Восстановление пароля по email
   */
  eventPasswordRestoreByEmail () {
    this.pushDataToDataLayer({ 'event': 'Password_E-mail' })
  }

  /**
   * Восстановление пароля по номеру телефона
   */
  eventPasswordRestoreByPhone () {
    this.pushDataToDataLayer({ 'event': 'Password_Phone' })
  }

  /**
   * Неудачное восстановление пароля по email'у
   */
  eventPasswordRestoreErrorByEmail () {
    this.pushDataToDataLayer({ 'event': 'Email_error' })
  }

  /**
   * Неудачное восстановление пароля по телефону
   */
  eventPasswordRestoreErrorByPhone () {
    this.pushDataToDataLayer({ 'event': 'Phone_error' })
  }

  /**
   * Удаление из корзины товара
   */
  eventDeleteItemFromCart () {
    this.pushDataToDataLayer({ 'event': 'DeleteItem' })
  }

  /**
   * Удаление из корзины списка товаров товара
   */
  eventDeleteItemsListFromCart () {
    this.pushDataToDataLayer({ 'event': 'DeleteItems' })
  }

  /**
   * Покладка товара в корзину
   * @param {number} sid
   */
  eventItemInCart (sid) {
    this.pushDataToDataLayer({ 'event': 'add_cart', 'eventProductId': sid })
  }

  /**
   * Нажали на кнопку `добавить` в форме добавления товара по артикулу
   */
  eventAddInCartByArticul () {
    this.pushDataToDataLayer({ 'event': 'add_items' })
  }

  /**
   * Нажали на кнопку `Добавить товары по артикулу`
   */
  eventOpenAddByArticulForm () {
    this.pushDataToDataLayer({ 'event': 'more_items' })
  }

  /**
   * Клик на кнопку добавления товара из рекомендаций
   */
  eventClickItemButtonRecommendation () {
    this.pushDataToDataLayer({ 'event': 'addToCartRR' })
  }

  /**
   * Клик на картинку товара из рекомендаций
   */
  eventClickItemImgRecommendation () {
    this.pushDataToDataLayer({ 'event': 'imgRR' })
  }

  /**
   * Клик на название товара из рекомендаций
   */
  eventClickItemNameRecommendation () {
    this.pushDataToDataLayer({ 'event': 'textRR' })
  }

  /**
   * Добавление товара в избранное
   * @param {Item} model Модель товара.
   */
  eventItemInFavorite (model) {
    this.pushDataToDataLayer({
      'event': 'In-favorite',
      article: model.get('item_sid'),
      rootCategory: model.get('root_category_id'),
    })
  }

  /**
   * Удаление товара из избранного
   * @param {Item} model Модель товара.
   */
  eventItemOutFavorite (model) {
    this.pushDataToDataLayer({
      'event': 'Out-favorite',
      article: model.get('item_sid'),
      rootCategory: model.get('root_category_id'),
    })
  }

  /**
   * Переключение вкладки на странице товара
   * @param {jQuery} $el Элемент таба.
   */
  eventSwitchProductTab ($el) {
    // устанавливаем флаги и временные переменные
    if (!this.switchProductTab) {
      this.switchProductTab = {
        firstEvent: true,
        previousElement: '',
      }
    }

    // нажатие на тот же самый таб
    if (
      this.switchProductTab.previousElement
      && this.switchProductTab.previousElement.data('contentId') === $el.data('contentId')
    ) {
      return
    }
    this.switchProductTab.previousElement = $el

    // на первое событие не реагируем потому как оно исходит от скрипта, нам же нужны только события от человека
    if (this.switchProductTab.firstEvent) {
      this.switchProductTab.firstEvent = false
      return
    }

    switch ($el.data('contentId')) {
      case '#details_tab' :
        this.pushDataToDataLayer({ 'event': 'characteristic' })
        break
      case '#questions_tab' :
        this.pushDataToDataLayer({ 'event': 'comment' })
        break
    }
  }

  /**
   * Отправка данных в dataLayer
   *
   * @param {Object} data Данные для datalayer.
   */
  pushDataToDataLayer (data) {
    if (window.location.search.match('SIMA_NO_GTM') === null) {
      this.dataLayer.push(data)
    }
  }
}
